import React,{useCallback,useEffect}from 'react';
import { TextField, MenuItem, Tooltip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

// import useStyles from './styles';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
// import { getListView} from '../../../store/actions/module.actions';

const Enum = ({ field, onChange, errors = {}, value, small = false, helperText = "", variant = "outlined", fullWidth = true, disabled }) => {
  // const classes = useStyles();
  let iserror = errors[field.name] ? true : false;
	const dispatch = useDispatch();

  
  
  const renderOptions = () => {
    let optionsToRender = [];
    if(field.looping){
      switch(field.loopType){
        case 'number':
          for (let i = field.start; i <= field.end; i++) {
            optionsToRender.push(
              <MenuItem key={i} value={i}>
                <span>{field.preStart}{i}{field.preEnd}</span>
              </MenuItem>
            );
          }
          break;
          default:
            break;
      }
      for (let optionKey in field.options) {
        optionsToRender.push(
          <MenuItem key={optionKey} value={optionKey}>
            <span>{field.options[optionKey]}</span>
          </MenuItem>
        );
      }
    }else{
      for (let optionKey in field.options) {
        optionsToRender.push(
          <MenuItem key={optionKey} value={optionKey}>
            <span>{field.options[optionKey]}</span>
          </MenuItem>
        );
      }
    }
   
    return optionsToRender;
  };
  return (
<>    

<Tooltip
      title={field.comment || ''}
      disableHoverListener={field.comment ? false : true}
      placement="top-start"
      disableFocusListener={field.comment ? false : true}
      disableTouchListener={field.comment ? false : true}
    >
        
      <TextField
        id={field.name}
        name={field.name}
        error={iserror}

        required={field.required === 'true' ? true : false}
        select
        label={field.label}
        value={value ? value : ""}
        onChange={(e) => onChange(e.target.value)}
        variant={variant}
        fullWidth={fullWidth}
        size={small ? "small" : "medium"}
        helperText={helperText !== "" ? helperText : errors[field.name] ? errors[field.name] : null}
        disabled={disabled}
        InputProps={{
          className: field.class,

        }}
      >
        {renderOptions()}
      </TextField>
    </Tooltip>

    </>
  );
};

export default Enum;
